import { render, staticRenderFns } from "./ChangelogTable.vue?vue&type=template&id=5a5da41d&"
import script from "./ChangelogTable.vue?vue&type=script&lang=ts&"
export * from "./ChangelogTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports